import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, FileText, Wand2, Palette, Package, MessageSquare, Rocket } from 'lucide-react';
const days = [{
  day: 1,
  title: 'Descubrimiento con IA',
  description: 'Nicho en 5 min con prompts maestros',
  icon: Sparkles
}, {
  day: 2,
  title: 'Estructura Inteligente',
  description: 'IA crea índice y capítulos',
  icon: FileText
}, {
  day: 3,
  title: 'Redacción Mágica',
  description: 'IA redacta, tú revisas',
  icon: Wand2
}, {
  day: 4,
  title: 'Diseño Pro en Segundos',
  description: 'Herramientas IA para PDF premium',
  icon: Palette
}, {
  day: 5,
  title: 'Empaque de tu Activo',
  description: 'Descarga producto listo',
  icon: Package
}, {
  day: 6,
  title: 'Kit de Ventas "Copy-Paste"',
  description: 'Guiones Instagram/WhatsApp',
  icon: MessageSquare
}, {
  day: 7,
  title: '¡Lanzamiento Express!',
  description: 'Negocio listo, primeros $110 MXN',
  icon: Rocket
}];
export function SevenDayPlan() {
  return <section className="py-16 px-4 bg-white" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-161">
          <h2 className="font-serif text-3xl md:text-4xl text-dark mb-4" data-id="element-162">
            Tu Plan de 7 Días con IA
          </h2>
          <p className="text-lg text-body" data-id="element-163">
            Un sistema paso a paso donde la inteligencia artificial hace el
            trabajo pesado
          </p>
        </motion.div>

        <div className="relative" data-id="element-164">
          {/* Timeline line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-border transform -translate-x-1/2" data-id="element-165" />

          <div className="space-y-12" data-id="element-166">
            {days.map((day, index) => {
            const Icon = day.icon;
            const isEven = index % 2 === 0;
            return <motion.div key={day.day} initial={{
              opacity: 0,
              x: isEven ? -50 : 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className={`relative flex flex-col lg:flex-row items-center gap-8 ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'}`} data-id="element-167">
                  {/* Content Card */}
                  <div className={`w-full lg:w-5/12 ${isEven ? 'lg:text-right' : 'lg:text-left'}`} data-id="element-168">
                    <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-169">
                      <div className={`flex items-center gap-3 mb-3 ${isEven ? 'lg:justify-end' : 'lg:justify-start'} justify-start`} data-id="element-170">
                        <Icon className="w-6 h-6 text-primary" data-id="element-171" />
                        <h3 className="font-bold text-xl text-dark" data-id="element-172">
                          {day.title}
                        </h3>
                      </div>
                      <p className="text-body" data-id="element-173">{day.description}</p>
                    </div>
                  </div>

                  {/* Center Badge */}
                  <div className="relative z-10 flex-shrink-0" data-id="element-174">
                    <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg" data-id="element-175">
                      {day.day}
                    </div>
                  </div>

                  {/* Spacer for alignment */}
                  <div className="hidden lg:block w-5/12" data-id="element-176" />
                </motion.div>;
          })}
          </div>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl text-dark text-center font-semibold mt-16" data-id="element-177">
          No necesitas perfección. Necesitas terminar.
        </motion.p>
      </div>
    </section>;
}